import React, { useState } from 'react';
import './SearchTicketModal.css';

interface SearchTicketModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (ticketData: string) => void; // Pass string instead of any
    placeholder?: string;
}

const SearchTicketModal: React.FC<SearchTicketModalProps> = ({isVisible, onClose, onSearch, placeholder}) => {
    const [uniqueCode, setUniqueCode] = useState('');

    const handleSearchClick = async () => {
        if (!uniqueCode.trim()) return;
        onSearch(uniqueCode);
        onClose()
        setUniqueCode('')
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">
                            search
                        </span>
                        <p className="buscar-header">
                            BUSCAR
                        </p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">
                            close
                        </span>
                    </div>
                </div>
                <div className="body">
                    <input
                        id="codigo"
                        value={uniqueCode}
                        onChange={(e) => setUniqueCode(e.target.value)}
                        placeholder={placeholder}
                    />
                </div>
                <div className="search-button">
                    <button onClick={handleSearchClick}>
                        BUSCAR
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchTicketModal;
